module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNSIgaGVpZ2h0PSI1IiB2aWV3Qm94PSIwIDAgNSA1IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8Y2lyY2xlIGN4PSIyLjUiIGN5PSIyLjUiIHI9IjIuNSIgZmlsbD0iI0E4QjJDOCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/RF_assets/icons/oval-gray.svg
// module id = RaH5
// module chunks = 28